import React, { FunctionComponent } from 'react';
import { ActivityIndicator, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import FastImage from 'react-native-fast-image';
import Theme from '../../theme';
import { i18n } from '../../utils';
import { defaultScale } from '../../utils/scaling';

export interface IMessagingButtonsProps {
  facebookMessengerLink: string | null;
  whatsAppLink: string | null;
  openMessagingApp: (app: string) => void;
  disabled: boolean;
  buttonLoading: string | null,
}

const messagingIcons = {
  whatsapp: require('../../assets/images/whatsapp.png'),
  facebookMessenger: require('../../assets/images/facebook-messenger.png'),
};

export const MessagingButtons: FunctionComponent<IMessagingButtonsProps> = ({
                                                                              facebookMessengerLink,
                                                                              whatsAppLink,
                                                                              openMessagingApp,
                                                                              disabled,
                                                                              buttonLoading,
                                                                            }) => (

  <>
    <Text style={styles.chatToUs}>{i18n.t('dashboard:chatToUs')}</Text>
    <Text style={styles.helpMessage}>{i18n.t('dashboard:messengerHelp')}</Text>
    <View style={[styles.buttonContainer, { justifyContent: whatsAppLink ? 'space-between' : 'center' }]}>
      {
        whatsAppLink &&
        <TouchableOpacity
          onPress={() => openMessagingApp(whatsAppLink)}
          style={[styles.largeButton, { width: '48%', backgroundColor: disabled || buttonLoading ? Theme.GREY_LIGHT : Theme.PRIMARY }]}
          disabled={disabled}
        >
          {
            buttonLoading === whatsAppLink &&
            <ActivityIndicator
              size='small'
              color={Theme.GREY}
              animating={true}
            />
          }
          {
            buttonLoading !== whatsAppLink &&
            <FastImage
              resizeMode='contain'
              tintColor={disabled ? Theme.GREY : Theme.WHITE}
              style={{
                width: defaultScale(20),
                height: defaultScale(20),
              }}
              source={messagingIcons.whatsapp}
            />
          }
          <Text
            style={[styles.buttonText, { color: disabled || buttonLoading ? Theme.GREY : Theme.WHITE }]}>
            {i18n.t('dashboard:whatsApp')}</Text>
        </TouchableOpacity>
      }
      {
        facebookMessengerLink &&
        <TouchableOpacity
          onPress={() => openMessagingApp(facebookMessengerLink)}
          style={[styles.largeButton, {
            width: whatsAppLink ? '48%' : '100%',
            backgroundColor: disabled || buttonLoading ? Theme.GREY_LIGHT : Theme.PRIMARY,
          }]}
          disabled={disabled}
        >
          {
            buttonLoading === facebookMessengerLink &&
            <ActivityIndicator
              size='small'
              color={Theme.GREY}
              animating={true}
            />
          }
          {
            buttonLoading !== facebookMessengerLink &&
            <FastImage
              resizeMode='contain'
              tintColor={disabled ? Theme.GREY : Theme.WHITE}
              style={{
                width: defaultScale(20),
                height: defaultScale(20),
              }}
              source={messagingIcons.facebookMessenger}
            />
          }
          <Text
            style={[styles.buttonText, { color: disabled || buttonLoading ? Theme.GREY : Theme.WHITE }]}>
            {i18n.t('dashboard:facebookMessenger')}</Text>
        </TouchableOpacity>
      }
    </View>
  </>
);

const styles = StyleSheet.create({
  buttonContainer: {
    flexDirection: 'row',
    marginTop: defaultScale(12),
  },
  largeButton: {
    borderRadius: defaultScale(5),
    justifyContent: 'center',
    alignItems: 'center',
    height: defaultScale(90),
  },
  buttonText: {
    ...Theme.textStyle.bodyCopyBold,
    paddingTop: defaultScale(10),
  },
  chatToUs: {
    ...Theme.textStyle.heading,
    paddingBottom: defaultScale(10),
    color: Theme.BLACK,
  },
  helpMessage: {
    ...Theme.textStyle.bodyCopyReg,
    paddingBottom: defaultScale(13),
    color: Theme.GREY_DARK_MEDIUM,
  },
});
